<template>
  <div>
    <div class="dialog-table-panel background">
      <!-- List of CustomPropertyValues for selected Client -->
      <div class="dialog-table-panel" v-if="selectedClient">
        <table
          class="table table-striped table-hover main-table"
          style="overflow-y: unset"
        >
          <thead>
            <tr>
              <th class="text-center w40">{{ lang.S0170 }}</th>
              <th class="text-center w60">{{ lang.S0171 }}</th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar client-policies-table">
            <tr
              v-for="(property, index) in customPropertyValuePairs"
              :key="index"
            >
              <td class="td-cb-policies w40 moreheadroom">
                <a
                  class="table-header"
                  role="button"
                  @click="togglePermitted(property)"
                  >{{ property.LocationPropertyName }}</a
                >
              </td>
              <td class="w60" style="text-align: left">
                <div class="reset-this">
                  <treeselect
                    :placeholder="lang.S0041"
                    v-model="property.SelectedItems"
                    :options="property.LocationPropertyValues"
                    :load-options="() => {}"
                    :auto-load-root-options="false"
                    :multiple="true"
                    :limit="5"
                    :searchable="true"
                    :showCount="true"
                    :flat="true"
                    valueFormat="id"
                    showCountOf="LEAF_DESCENDANTS"
                    :disabled="!property.LocationPropertyValues"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";
import policiesMixin from "../../mixins/policiesmixin";
import "../../styles/usermanagement.css";

export default {
  name: "CustomPropertiesPoliciesControl",
  data() {
    return {
      customPropertyValuePairs: [],
    };
  },
  mixins: [policiesMixin],
  props: {
    user: {
      type: Object,
      // required: true
    },
    lang: {
      type: Object,
      required: true,
    },
    selectedClient: {
      type: String,
      // required: true
    },
  },
  methods: {
    togglePermitted(item) {
      if (!item.LocationPropertyValues) return;
      if (item.SelectedItems.length === item.LocationPropertyValues.length) {
        item.SelectedItems = [];
        return;
      } else {
        item.LocationPropertyValues.forEach((element) => {
          item.SelectedItems.push(element.id);
        });
      }
    },
    getPropertySubItems(property) {
      if (!property.LocationPropertyValues) return [];
      return property.LocationPropertyValues;
    },
    getSelectedSubItems(items) {
      let result = [];
      if (!items || items.length < 1) return result;
      items.forEach((element) => {
        if (!element.LocationPropertyValues) return;
        let el = {
          LocationPropertyGuid: element.LocationPropertyGuid,
          LocationPropertyValues: [],
        };
        element.LocationPropertyValues.forEach((subElement) => {
          if (_.includes(element.SelectedItems, subElement.id)) {
            el.LocationPropertyValues.push(subElement.label);
          }
        });
        if (el.LocationPropertyValues.length > 0) result.push(el);
      });
      return result;
    },
    saveChanges(successCallback, errorCallback) {
      let itms = this.getSelectedSubItems(this.customPropertyValuePairs);
      let url = `api/UserSecurity/${this.user.UserId}/LocationProperties`;
      this.putItems(
        this,
        url,
        itms,
        "CustomPropertyPolicies",
        successCallback,
        errorCallback
      );
    },
    convertToTreeselectData(_data) {
      _.forEach(_data, (item) => {
        var selected = [];
        var nr = 0;
        _.forEach(item.LocationPropertyValues, (val) => {
          val.id = nr++;
          if (val.Permitted) selected.push(val.id);
          val.label = val.LocationPropertyValue;
          delete val.LocationPropertyValue;
        });
        item.SelectedItems = selected;
      });
      return _data;
    },
    loadPolicies(successCallback, errorCallback) {
      if (!this.selectedClient) return;
      this.customPropertyValuePairs = [];
      let url = `api/UserSecurity/${this.user.UserId}/LocationProperties/Client/${this.selectedClient}`;

      $.ajax({
        method: "GET",
        url: url,
        success: (data) => {
          this.customPropertyValuePairs = _.isEmpty(data)
            ? []
            : this.convertToTreeselectData(data);
          successCallback();
        },
        error: () => {
          console.error(
            "Data access failed in CustomPropertiesPoliciesControl.loadPolicies()"
          );
          errorCallback();
        },
      });
    },
  },
};
</script>

<style scoped>
tbody {
  min-height: calc(100vh - 390px);
  overflow: auto;
}

.moreheadroom {
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// CustomPropertiesPoliciesControl.vue?3a9fce88